<template>
  <div class="footer" :class="classes">
    <div class="footer__container">
      <div class="footer__rmn">
        <a href="http://www.grandpalais.fr/fr/evenement/jardins" target="_blank">
          <img src="/static/assets/img/logo_rmn.png" alt="Rmn">
        </a>
      </div>

      <nav class="footer__nav">
        <router-link class="nav__link" :to="{ name: 'about' }">
          À propos
        </router-link>
        <!-- <a href="" class="nav__link">À propos</a> -->
        <p class="nav__credits">© RMN - Grand Palais</p>
      </nav>
    </div>
  </div>
</template>

<script>
import 'styles/components/footer.styl'
import Emitter from 'core/Emitter'
import TweenMax from 'gsap'

export default {
  name: 'footer',
  data () {
    return {
    }
  },
  computed: {
    classes () {
      let c = {}
      c['footer--about'] = this.$route.name === 'about'
      return c
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** Footer.vue?5fe18f3e
 **/